/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useSelector } from 'react-redux';
import EmailPreference from './EmailPreference';
import CommunicationCenter from '../CommunicationCenter/CommunicationCenter';
import { getFeatureFlag } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const EmailPreferenceContainer = () => {
    const isRecipientBookEnabled = useSelector(getFeatureFlag('is-recipient-book-enabled'));
    return (
        <>
            {isRecipientBookEnabled
                ? (<CommunicationCenter />)
                : (<EmailPreference />)}
        </>
    );
};

export default EmailPreferenceContainer;
